module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-2"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "fullscreen"
    },
    model: {
      value: (_vm.isModalExportar),
      callback: function($$v) {
        _vm.isModalExportar = $$v
      },
      expression: "isModalExportar"
    }
  }, [(_vm.isModalExportar) ? _c('parametros-exportacion', {
    attrs: {
      "id": _vm.idReporte,
      "preview": _vm.tipoPreview,
      "tipo": _vm.tipoReporte,
      "filtros": _vm.filtrosDraft
    },
    on: {
      "close": _vm.closeDialogExportar
    }
  }) : _vm._e()], 1), _c('v-card', {
    staticClass: "mx-auto elevation-1"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("Visualizador de reportes")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-13"
  }, [_vm._v("Configura los parametros y exporta")])], 1)]), _c('v-divider'), _c('v-sheet', [_c('div', {
    staticClass: "pa-1",
    attrs: {
      "dense": "dense"
    }
  }, [_c('div', {
    staticClass: "d-flex ai-center"
  }, [(_vm.tipoPreview === 'save') ? _c('div', {
    staticClass: "flex-1"
  }, [_c('strong', {
    staticClass: "font-size-13 is-bold ml-4"
  }, [_vm._v(_vm._s(_vm.datosReporte.titulo))])]) : _c('div', {
    staticClass: "flex-1"
  }, [_c('strong', {
    staticClass: "font-size-13 is-bold ml-4"
  }, [_vm._v("Reporte de tipo draft")])]), _c('v-card', {
    staticClass: "d-flex elevation-0 ai-center"
  }, [_c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "fab": "fab",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.fetchDatosReporte()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")])], 1), _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "fab": "fab",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.openDialogExportar()
      }
    }
  }, [_c('v-icon', [_vm._v("import_export")])], 1)], 1)], 1)]), _c('v-divider'), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "box-table",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2"
    }
  }, [_c('v-data-table', {
    staticClass: "overflow-y-auto",
    attrs: {
      "headers": _vm.headerTable,
      "dense": "dense",
      "fixed-header": "fixed-header",
      "items": _vm.lista,
      "disable-pagination": true,
      "hide-default-footer": "hide-default-footer"
    },
    scopedSlots: _vm._u([{
      key: "item.descripcionFalla",
      fn: function(ref) {
        var item = ref.item;

        return [(item.codigoFalla) ? _c('strong', {
          staticClass: "font-size-11"
        }, [_vm._v(_vm._s(item.codigoFalla))]) : _vm._e(), _c('strong', {
          staticClass: "font-size-11"
        }, [_vm._v(" - " + _vm._s(item.descripcionFalla))])]
      }
    }, {
      key: "item.descripcionEstado",
      fn: function(ref) {
        var item = ref.item;

        return [(item.estado) ? _c('strong', {
          staticClass: "font-size-11"
        }, [_vm._v(_vm._s(item.estado))]) : _vm._e(), _c('strong', {
          staticClass: "font-size-11"
        }, [_vm._v(" - " + _vm._s(item.descripcionEstado))])]
      }
    }, {
      key: "item.tipoticket",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-size-11"
        }, [_vm._v(" " + _vm._s(item.tipoticket))])]
      }
    }, {
      key: "item.fechaRegistro",
      fn: function(ref) {
        var item = ref.item;

        return [_c('strong', {
          staticClass: "font-size-11"
        }, [_vm._v(_vm._s(_vm._f("formatoFecha")(item.fechaRegistro)))])]
      }
    }, {
      key: "item.numeroInformeTecnico",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-size-11"
        }, [_vm._v(" " + _vm._s(item.numeroInformeTecnico))])]
      }
    }, {
      key: "item.serie",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-size-11"
        }, [_vm._v(" " + _vm._s(item.serie))])]
      }
    }, {
      key: "item.area",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-size-11"
        }, [_vm._v(" " + _vm._s(item.area))])]
      }
    }, {
      key: "item.tipoArea",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-size-11"
        }, [_vm._v(" " + _vm._s(item.tipoArea))])]
      }
    }, {
      key: "item.zonaGarantia",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-size-11"
        }, [_vm._v(" " + _vm._s(item.zonaGarantia))])]
      }
    }, {
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('div', {
          staticClass: "d-flex ai-center",
          class: {
            'ma-1': !_vm.isMovil
          }
        }, [_c('v-btn', {
          staticClass: "mr-2",
          attrs: {
            "x-small": "x-small",
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.goTo('/ticket/' + item.numero)
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-1",
          attrs: {
            "size": "15"
          }
        }, [_vm._v("visibility")]), _vm._v("ver ticket")], 1)], 1)]
      }
    }, {
      key: "item.razonSocial",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex fd-column"
        }, [(item.codigoCliente) ? _c('span', {
          staticClass: "text-muted font-size-11"
        }, [_vm._v(_vm._s(item.codigoCliente))]) : _vm._e(), _c('strong', {
          staticClass: "font-size-11"
        }, [_vm._v(" " + _vm._s(item.razonSocial))])])]
      }
    }, {
      key: "item.abierto",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          attrs: {
            "small": "small",
            "color": item.abierto ? 'success' : 'error'
          }
        }, [_c('span', {
          staticClass: "font-weight-700 font-size-11"
        }, [_vm._v(" " + _vm._s(item.abierto ? 'Abierto' : 'Cerrado'))])])]
      }
    }])
  })], 1), _c('v-divider'), _c('v-card', {
    staticClass: "pa-2 elevation-0"
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v(_vm._s(_vm.lista.length) + " registros encontrados")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27e85b6b","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_reporte_previsualizar.vue
// module id = 486
// module chunks = 1